<template>
   <form class="container ">
        <div class="d-flex justify-content-center my-5">
            <h1 class="center title">Demande Detail</h1>
        </div>
        <div class="row mt-8">
            <div class="d-flex justify-content-center my-5">
                <h1 class="center title2">DEMANDE DE DEVIS</h1>
            </div>
        </div>
        <h1 class="title3 mb-6"> TYPE DE SERVICE :</h1>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <h1 class="title4">Digital :</h1>
                    <div class="box">Animation des réseaux sociaux</div>
                    <div class="box">Développement Web</div>
                    <div class="box">Développement mobile</div>
                    <div class="box">Transformation digitale</div>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-6">
                    <h1 class="title4">Production événementielle</h1>
                    <div class="box">Conférences</div>
                    <div class="box">Salons professionnels</div>
                    <div class="box">Séminaires</div>
                    <div class="box">Réunions internes de l’entreprise et reunions
                        d’affaires périodiques</div>
                    <div class="box">Evénements de leadership éclairé et de réseautage</div>
                    <div class="box">Cérémonies et galas</div>
                    <div class="box">Lancements de produits</div>
                    <div class="box">Salons de l’emploi et événements de recrutement</div>
                    <div class="box">Team building</div>
                    <div class="box">Evénements virtuels</div>
                    <div class="box">Concert de musique</div>
                    <div class="box">Autres…</div>       
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <h1 class="title4">Stratégie :</h1>
                    <div class="box">Stratégies marketing</div>
                    <div class="box">Stratégie de communication</div>
                    <div class="box">Responsabilité sociale d’entreprises</div>
                </div>
            </div>
            <div class="col">
                <div class="form-group mb-8">
                    <h1 class="title4">création de contenu :</h1>
                    <div class="box">Photos</div>
                    <div class="box">Vidéos</div>
                    <div class="box">Design</div>
                </div>
            </div>
        </div>
        <h1 class="title3 mb-5">DATE DU SERVICE VOULU:</h1>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <div class="box">Rapidement;</div>
                    <div class="box">Pour ce mois-ci;</div>
                    <div class="box">Dans le trimestre;</div>

                </div>
            </div>
            <div class="col">
                <div class="form-group mb-6">
                    <div class="box">Pour le semestre;</div>
                    <div class="box">Courant d’année;</div>
                    <div class="box">Nous n’avons pas encore de visibilité.</div>
      
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <div class="box">Rapidement;</div>
                    <div class="box">Pour ce mois-ci;</div>
                    <div class="box">Dans le trimestre;</div>

                </div>
            </div>
            <div class="col">
                <div class="form-group mb-6">
                    <div class="box">Pour le semestre;</div>
                    <div class="box">Courant d’année;</div>
                    <div class="box">Nous n’avons pas encore de visibilité.</div>
                </div>
            </div>
        </div>


         <div class="row">
            <div class="col">
                <div class="form-group">
                    <h1 class="title5">Adresse mail :</h1>
                    <div class="box box5"></div>
                    <h1 class="title5">Numéro de téléphone :</h1>
                    <div class="box box5"></div>
                    <h1 class="title5">Informations sur votre société:</h1>
                    <div class="box box5"></div>

                </div>
            </div>
            <div class="col">
                <div class="form-group mb-6">
                    <h1 class="title5">Informations sur le projet que vous voulez <br> atteindre avec notre société:</h1>
                    <div class="box boxarea"></div>
                    
                </div>
            </div>
        </div>




        <!-- <div class="row2">
            <div class="col2">
                <div class="group2">
                    <label for="email">Adresse mail: :</label>
                    <input type="email" id="email" required>
                </div>
                <div class="group2">
                    <label for="tele">Numéro de téléphone:</label>
                    <input type="tel" id="tel" required>
                </div>
                <div class="group2">
                    <label for="informaion">Informations sur votre société:</label>
                    <input type="text" id="text" required>
                </div>
            </div>
            <div class="col2" >
                <div class="group2">
                    <label for="message">Informations sur le projet que vous voulez <br>
atteindre avec notre société:</label>
                    <textarea id="message" rows="8"  required></textarea>
                </div>
            </div>
        </div> -->
        <div class="enregistrer">
            <button type="submit" class="btn btn-light mr-4" >Enregistrer</button>
        </div>
    </form> 
</template>


<style lang="scss" scoped>
.title{
  color:white;
}
.title2{
  color:black;
  font-size: 30px;
}
.title3{
  color:#8E7136;
  font-size: 25px;
}
.title4{
  color:black;
  font-size: 20px;
}
.title5{
    color:#A68D5B;
    font-size: 16px;
}
.box{
  width: 80%;
  border-radius: 6px;
  color: black;
  border: 1px solid black;
  margin-bottom: 2%;
  text-align: center;
  padding: 1%;
}
.box5{
      border: 2px solid #A68D5B;
      height:40px;
}
.boxarea{
    width: 80%;
    height:200px;
    border-radius: 6px;
    color: black;
    border: 2px solid #A68D5B;
    margin-bottom: 2%;
    text-align: center;
    padding: 1%;
}
.enregistrer{
    margin-right: 10%;
    display: flex;
    justify-content: center;
}
.row2{
    display: flex;
    justify-content:space-between;
    .col2{
        .group2{
            margin-bottom: 6%;
            label{
                font-size:15px;
                color:#A68D5B;
            }

            input{
                margin-bottom: 1%;
                outline:none;
                border:2px solid #A68D5B;
                border-radius:6px;
                color:black;
                padding:2px;
                width: 85%;
                height:38px;
            }
            textarea{
                outline:none;
                border:2px solid #A68D5B;
                border-radius:6px;
                color:black;
                padding:2px;
                width:90%;
            }
        }
    }
}
</style>